import { Pipe, PipeTransform, inject } from '@angular/core';
import { FileManagerService } from 'src/app/modules/private/file-manager/services/file-manager.service';

@Pipe({
  name: 'fileCategoryColor',
  standalone: true,
})
export class FileCategoryColorPipe implements PipeTransform {
  readonly fileManagerService = inject(FileManagerService);

  transform(type: string): string {
    const exists = this.fileManagerService.categories$
      .getValue()
      .find(i => i.value === type);
    return exists?.color || '#1c1c1c';
  }
}
